import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_TOKEN_INPUT: `${cleanedFilename(__filename)}-add-token-input`,
  OFFICE_DROPDOWN: `${cleanedFilename(__filename)}-office-dropdown`,
  CANCEL: `${cleanedFilename(__filename)}-cancel`,
  SAVE: `${cleanedFilename(__filename)}-save`,
};
